// extracted by mini-css-extract-plugin
export var inlineLink = "_42-0";
export var inlineLinkButton = "_42-1";